import React, { useState } from 'react';
import * as styles from './stacked-3.0-ebook.module.less';
import { default as SiteLayout } from '../components/sitelayout';
import { Container } from '../components/container';
import { Row, Col, message } from 'antd';
import { graphql } from 'gatsby';
import { convertUrltoCdn } from '../utils/helpers';
import { AButton } from '../components/abutton';
import { AForm } from '../components/aform';

const PartnerEbook = ({ data, location }) => {
  const seoTitle = data.strapiSeo.seo_title;
  const seoDescription = data.strapiSeo.seo_description;
  const seoKeywords = data.strapiSeo.seo_keywords;
  const seoImage = data.strapiSeo.seo_image;

  const [download, setDownload] = useState('');
  const [messageApi, contextHolder] = message.useMessage();

  const partners = [
    {
      id: 1,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo.png',
    },
    {
      id: 2,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-1.png',
    },
    {
      id: 3,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-2.png',
    },
    {
      id: 4,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-3.png',
    },
    {
      id: 5,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-4.png',
    },
    {
      id: 6,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-5.png',
    },
    {
      id: 7,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-6.png',
    },
    {
      id: 8,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-7.png',
    },
    {
      id: 9,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-8.png',
    },
    {
      id: 10,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-9.png',
    },
    {
      id: 11,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-10.png',
    },
    {
      id: 12,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-11.png',
    },
    {
      id: 13,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-12.png',
    },
    {
      id: 14,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-13.png',
    },
    {
      id: 15,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-14.png',
    },
    {
      id: 16,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-15.png',
    },
    {
      id: 17,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-16.png',
    },
    {
      id: 18,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-17.png',
    },
    {
      id: 19,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-18.png',
    },
    {
      id: 20,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-19.png',
    },
    {
      id: 21,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-20.png',
    },
    {
      id: 22,
      icon: 'https://cdn.runalloy.com/partner-ebook/partners/partner-logo-21.png',
    },
  ];

  const downloadEbook = () => {
    download.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <SiteLayout
      metaTitle={seoTitle}
      metaDescription={seoDescription}
      metaKeywords={seoKeywords}
      seoImage={seoImage && seoImage.url ? convertUrltoCdn(seoImage.url) : ''}
      location={location}
    >
      <section className={styles.foldSection}>
        <div className={styles.overlay} />
        <div className={styles.content}>
          <Container>
            <Row gutter={24} justify="space-between" align="center">
              <Col sm={0} xs={24}>
                <div className={styles.ebook}>
                  <img
                    src="https://cdn.runalloy.com/partner-ebook/ebook-cover.png"
                    alt="ebook-cover"
                  />
                </div>
              </Col>
              <Col sm={12} xs={24}>
                <h1 className={styles.tag}>E-book</h1>
                <h1 className={styles.title}>
                  Stacked 3.0: How to build a profitable tech stack from A-Z
                </h1>
                <div className={styles.divider} />
                <div className={styles.description}>
                  Shopify has over 6,000 apps in its public app store. This
                  leaves merchants with the burning question: Which apps should
                  I choose to power my tech stack? We partnered with 7 brands
                  and 16 companies to show you how to choose the right tools to
                  scale your business – in 140 pages.
                </div>
                <AButton type="primary" onClick={downloadEbook}>
                  Download
                </AButton>
              </Col>
              <Col sm={12} xs={0}>
                <div className={styles.ebook}>
                  <img
                    src="https://cdn.runalloy.com/partner-ebook/ebook-cover.png"
                    alt="ebook-cover"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      <section className={styles.partnerSection}>
        <Container>
          <Row gutter={32} align="top" justify="space-between">
            <Col sm={10} xs={24}>
              <div className={styles.title}>
                Brought to you by some of <br />
                the <span>top voices in ecommerce</span>
              </div>
            </Col>
            <Col sm={14} xs={24}>
              <div className={styles.partners}>
                {partners.map(partner => {
                  return (
                    <img src={partner.icon} alt={partner.id} key={partner.id} />
                  );
                })}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className={styles.dtcStackSection}>
        <div className={styles.overlay} />
        <Container>
          <Row gutter={32}>
            <Col sm={12} xs={0} />
            <Col sm={12} xs={24}>
              <div className={styles.title}>
                We’re covering every part of the modern{' '}
                <a href="/dtc-stacks" target="_blank" rel="noreferrer">
                  DTC tech stack↗
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className={styles.formSection} ref={el => setDownload(el)}>
        <Container>
          <Row gutter={32} align="middle" justify="center">
            <Col sm={16} xs={24}>
              <div className={styles.title}>
                Ready to rebuild? <br />
                <span>Start here</span>
              </div>
              <div className={styles.description}>
                Fill in your info and we’ll email you your copy.
              </div>
              <div className={styles.form}>
                {contextHolder}
                <AForm
                  formId="df1505b9-303f-4081-bb60-83d526761769"
                  onSubmit={() => {
                    messageApi.open({
                      type: 'success',
                      content: 'Thanks! We’ve sent it to your email.',
                    });
                  }}
                  onReady={() => console.log('Form ready!')}
                  optText={
                    <>
                      I allow each of the tech providers who contributed to this
                      guide to use the contact information provided to send me
                      information about their products and services. This
                      includes{' '}
                      <a href="/" target="_blank" rel="noreferrer">
                        Alloy
                      </a>
                      ,{' '}
                      <a
                        href="https://www.shipbob.com/"
                        target="_blank"
                        rel="nofollow noreferrer"
                      >
                        Shipbob
                      </a>
                      ,{' '}
                      <a
                        href="https://www.loopreturns.com/"
                        target="_blank"
                        rel="nofollow noreferrer"
                      >
                        Loop
                      </a>
                      ,{' '}
                      <a
                        href="https://hawkemedia.com/"
                        target="_blank"
                        rel="nofollow noreferrer"
                      >
                        Hawke Media
                      </a>
                      ,{' '}
                      <a
                        href="https://www.peelinsights.com/"
                        target="_blank"
                        rel="nofollow noreferrer"
                      >
                        Peel Insights
                      </a>
                      ,{' '}
                      <a
                        href="https://www.omnisend.com/"
                        target="_blank"
                        rel="nofollow noreferrer"
                      >
                        Omnisend
                      </a>
                      ,{' '}
                      <a
                        href="https://www.referralcandy.com/"
                        target="_blank"
                        rel="nofollow noreferrer"
                      >
                        ReferralCandy
                      </a>
                      ,{' '}
                      <a
                        href="https://govalo.com/"
                        target="_blank"
                        rel="nofollow noreferrer"
                      >
                        Govalo
                      </a>
                      ,{' '}
                      <a
                        href="/integrations/recharge/"
                        target="_blank"
                        rel="nofollow noreferrer"
                      >
                        Recharge
                      </a>
                      ,{' '}
                      <a
                        href="https://sezzle.com/"
                        target="_blank"
                        rel="nofollow noreferrer"
                      >
                        Sezzle
                      </a>
                      ,{' '}
                      <a
                        href="https://www.gorgias.com/"
                        target="_blank"
                        rel="nofollow noreferrer"
                      >
                        Gorgias
                      </a>
                      ,{' '}
                      <a
                        href="https://enquirelabs.com/"
                        target="_blank"
                        rel="nofollow noreferrer"
                      >
                        EnquireLabs
                      </a>
                      ,{' '}
                      <a
                        href="https://www.justuno.com/"
                        target="_blank"
                        rel="nofollow noreferrer"
                      >
                        Justuno
                      </a>
                      ,{' '}
                      <a
                        href="https://www.prismfly.com/"
                        target="_blank"
                        rel="nofollow noreferrer"
                      >
                        Prismfly
                      </a>
                      ,{' '}
                      <a
                        href="https://postscript.io/"
                        target="_blank"
                        rel="nofollow noreferrer"
                      >
                        Postscript
                      </a>
                      , and{' '}
                      <a
                        href="https://www.okendo.io/"
                        target="_blank"
                        rel="nofollow noreferrer"
                      >
                        Okendo
                      </a>
                      .
                    </>
                  }
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </SiteLayout>
  );
};

export default PartnerEbook;

export const query = graphql`
  query {
    strapiSeo(page_slug: { eq: "stacked-3.0-ebook" }) {
      seo_title
      seo_description
      seo_keywords
      seo_image {
        url
      }
    }
  }
`;
